import React from 'react';

import Spinner from '@/components/common/Spinner/Spinner';

export default function AgGridLoadingOverlay() {
  return (
    <div>
      <Spinner />
    </div>
  );
}
